/**
 * Deep merge of multiple Objects
 *
 * Examples:
 * obj = merge({x: {a: 2}}, {x: {b: 3}})                => { x: { a: 2, b: 3 } }
 * obj = merge({x: {a: 2}}, {x: {b: 3}}, {x: {a: 1}})   => { x: { a: 1, b: 3 } }

 * @return {{}}
 */
export const merge = function () {
	let ret = {},
		i = 0,
		il = arguments.length,
		p;
	for (; i < il; i++) {
		for (p in arguments[ i ]) {
			try {
				if (arguments[ i ][ p ].constructor == Object) {
					ret[ p ] = merge(ret[ p ], arguments[ i ][ p ]);
				} else {
					ret[ p ] = arguments[ i ][ p ];
				}
			} catch (e) {
				ret[ p ] = arguments[ i ][ p ];
			}
		}
	}
	return ret;
};



// WEBPACK FOOTER //
// ./fe/web-3dliving/src/js/components/CookiesPolicy4/utils/merge.js